import React from 'react';
import { ROLES } from './permissions'; // استدعاء الرتب

const PricingPage = () => {
  // 1. جلب الرتبة الحالية للمستخدم
  const user = JSON.parse(localStorage.getItem('currentUser')) || { role: ROLES.FREE };
  const currentRole = user.role;

  // 2. دالة محاكاة الدفع (باش تجرب الترقية دابا)
  const handleUpgrade = (newRole) => {
    if (window.confirm(`Simulate payment for ${newRole.toUpperCase()} plan?`)) {
      const updatedUser = { ...user, role: newRole };
      localStorage.setItem('currentUser', JSON.stringify(updatedUser));
      alert(`🎉 Congratulations! You are now a ${newRole.toUpperCase()} member.`);
      window.location.reload(); // إعادة تحميل الصفحة باش يطبق التغيير
    }
  };

  // 3. بيانات الخطط (Data)
  const plans = [
    {
      id: 1,
      name: 'Free Starter',
      price: '$0',
      period: '/ forever',
      role: ROLES.FREE,
      color: '#b2bec3',
      features: [
        { text: 'Access to Basic Puzzles', included: true },
        { text: 'Max 5 Pages per Book', included: true },
        { text: 'Manual Creation Only', included: true },
        { text: 'Standard PDF Export', included: true },
        { text: 'Auto-Generator Tool', included: false }, // ❌
        { text: 'Commercial License', included: false }, // ❌
        { text: 'QR Code Solutions', included: false }, // ❌
      ]
    },
    {
      id: 2,
      name: 'Pro Creator',
      price: '$9.99',
      period: '/ month',
      role: ROLES.PRO,
      color: '#6c5ce7',
      recommended: true, // باش تبان مميزة
      features: [
        { text: 'Access to All Puzzles', included: true },
        { text: 'Max 50 Pages per Book', included: true }, // ✅
        { text: '⚡ Auto-Generator Access', included: true }, // ✅ الميزة القوية
        { text: 'Standard PDF Export', included: true },
        { text: 'No Ads', included: true },
        { text: 'Commercial License', included: true },
        { text: 'QR Code Solutions', included: false }, // ❌
      ]
    },
    {
      id: 3,
      name: 'Premium Agency',
      price: '$39.99',
      period: '/ month',
      role: ROLES.PREMIUM,
      color: '#fdcb6e',
      features: [
        { text: 'Everything in PRO', included: true },
        { text: 'Max 200 Pages per Book', included: true }, // ✅
        { text: '⚡ Unlimited Auto-Gen', included: true },
        { text: '💎 Pro PDF + QR Codes', included: true }, // ✅
        { text: 'Priority Email Support', included: true },
        { text: 'Early Access to New Games', included: true },
        { text: 'White Label (No Branding)', included: true },
      ]
    }
  ];

  return (
    <div style={{ padding: '40px 20px', background: '#f5f6fa', minHeight: '100vh' }}>
      
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <h1 style={{ color: '#2d3436', fontSize: '36px', marginBottom: '10px' }}>Choose Your Plan 🚀</h1>
        <p style={{ color: '#636e72', fontSize: '18px' }}>
          Unlock the full power of Darkou Puzzle Generator.
        </p>
      </div>

      {/* Grid of Plans */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        gap: '30px', 
        flexWrap: 'wrap' 
      }}>
        {plans.map((plan) => {
          const isCurrent = currentRole === plan.role;
          
          return (
            <div key={plan.id} style={{ 
              background: 'white', 
              borderRadius: '20px', 
              padding: '40px', 
              width: '320px', 
              boxShadow: plan.recommended ? '0 10px 30px rgba(108, 92, 231, 0.3)' : '0 4px 15px rgba(0,0,0,0.05)',
              border: plan.recommended ? '3px solid #6c5ce7' : '1px solid #eee',
              position: 'relative',
              transform: plan.recommended ? 'scale(1.05)' : 'scale(1)',
              display: 'flex', flexDirection: 'column'
            }}>
              
              {/* Badge for Recommended */}
              {plan.recommended && (
                <div style={{ 
                  position: 'absolute', top: '-15px', left: '50%', transform: 'translateX(-50%)', 
                  background: '#6c5ce7', color: 'white', padding: '5px 20px', borderRadius: '20px', 
                  fontWeight: 'bold', fontSize: '14px' 
                }}>
                  MOST POPULAR
                </div>
              )}

              {/* Plan Header */}
              <h3 style={{ color: plan.color, marginBottom: '10px', fontSize: '24px' }}>{plan.name}</h3>
              <div style={{ display: 'flex', alignItems: 'baseline', marginBottom: '30px' }}>
                <span style={{ fontSize: '40px', fontWeight: 'bold', color: '#2d3436' }}>{plan.price}</span>
                <span style={{ color: '#636e72' }}>{plan.period}</span>
              </div>

              {/* Features List */}
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 30px 0', flex: 1 }}>
                {plan.features.map((feature, i) => (
                  <li key={i} style={{ 
                    marginBottom: '15px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    color: feature.included ? '#2d3436' : '#b2bec3',
                    textDecoration: feature.included ? 'none' : 'line-through' 
                  }}>
                    <span style={{ marginRight: '10px', fontSize: '18px' }}>
                      {feature.included ? '✅' : '❌'}
                    </span>
                    {feature.text}
                  </li>
                ))}
              </ul>

              {/* Action Button */}
              <button 
                onClick={() => !isCurrent && handleUpgrade(plan.role)}
                disabled={isCurrent}
                style={{
                  width: '100%',
                  padding: '15px',
                  borderRadius: '10px',
                  border: 'none',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: isCurrent ? 'default' : 'pointer',
                  background: isCurrent ? '#dfe6e9' : (plan.recommended ? '#6c5ce7' : '#2d3436'),
                  color: isCurrent ? '#636e72' : 'white',
                  transition: '0.3s'
                }}
              >
                {isCurrent ? 'Current Plan' : `Choose ${plan.name}`}
              </button>

            </div>
          );
        })}
      </div>

    </div>
  );
};

export default PricingPage;